/**
 * RESPONSIBILITY: collect an email and a password and sign in. Nothing else.
 *
 * The fields start EMPTY. They previously shipped prefilled with a real account and
 * the literal password, plus a panel listing the demo logins — which put working
 * credentials in the production bundle, on the sign-in page, for anyone who opened
 * it. Convenient while there were seeded accounts; indefensible now that there are
 * none and the only administrator is generated per environment.
 */
import { useState } from 'react';
import { useAuth } from '../auth/AuthProvider';

export function LoginForm({ onDone, toRegister }: { onDone: () => void; toRegister: () => void }) {
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [err, setErr] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setBusy(true);
    const error = await login(email, password);
    setBusy(false);
    if (error) setErr(error); else onDone();
  }

  return (
    <form onSubmit={submit} className="form">
      <label>
        Email
        <input
          type="email" value={email} onChange={(e) => setEmail(e.target.value)}
          autoComplete="username" autoFocus required
        />
      </label>
      <label>
        Password
        <input
          type="password" value={password} onChange={(e) => setPassword(e.target.value)}
          autoComplete="current-password" required
        />
      </label>

      {err && <p className="ctl-error">{err}</p>}
      <button className="primary" disabled={busy}>{busy ? 'Signing in…' : 'Sign in'}</button>

      <div className="form-accounts">
        <button type="button" className="linkish" onClick={toRegister}>No account? Register</button>
      </div>
    </form>
  );
}
